import { render, staticRenderFns } from "./StepBasic.vue?vue&type=template&id=2b8a49b6&"
import script from "./StepBasic.vue?vue&type=script&lang=js&"
export * from "./StepBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports